import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { IEntity } from '@proximus/entity-manager';
import * as AliasActions from '../actions/alias.actions';
import { Alias } from '../../models/mailboxes.model';
import { TechnicalError } from '../../models/errors.model';
import { ApplicationState, getSelectedMailbox } from '../../../store/reducers';
import { AliasesService } from '../../service/aliases.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { BrandService } from 'src/app/services/brand.service';

@Injectable()
export class AliasEffects {
  @Effect()
  createAlias$: Observable<Action> = this.actions$.pipe(
    ofType(AliasActions.ActionTypes.CREATE),
    map((action: AliasActions.CreateAction) => action.payload),
    withLatestFrom(this.store.select(getSelectedMailbox)),
    switchMap(([action, mailbox]) => {
      const appBrand = this.brandService.getAppBrandValue();
      return this.aliasesService.createAlias(mailbox.mbxId, action, appBrand).pipe(
        map(
          (success: IEntity<Alias>) =>
            new AliasActions.CreateSuccessAction({
              mbxId: mailbox.mbxId,
              aliasId: action,
            }),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(new AliasActions.CreateFailAction(error.value)),
        ),
      );
    }),
  );

  @Effect()
  removeAlias$: Observable<Action> = this.actions$.pipe(
    ofType(AliasActions.ActionTypes.REMOVE),
    map((action: AliasActions.RemoveAction) => action.payload),
    withLatestFrom(this.store.select(getSelectedMailbox)),
    switchMap(([action, mailbox]) => {
      const appBrand = this.brandService.getAppBrandValue();
      return this.aliasesService.removeAlias(mailbox.mbxId, action, appBrand).pipe(
        map(
          (success: IEntity<Alias>) =>
            new AliasActions.RemoveSuccessAction({
              mbxId: mailbox.mbxId,
              aliasId: action,
            }),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(new AliasActions.RemoveFailAction(error.value)),
        ),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>,
    private aliasesService: AliasesService,
    private readonly brandService: BrandService,
  ) {}
}
